import React from 'react';
import * as S from './styles';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';

interface SamePrinterModalProps {
  show: boolean;
  onClose: () => void;
  onProceed: () => void;
}

const SamePrinterModal: React.FC<SamePrinterModalProps> = ({
  show,
  onClose,
  onProceed
}) => {
  const getText = useTranslationHelper();

  return (
    <S.StyledModal
      id="same-printer-modal"
      show={show}
      onClose={onClose}
      header={
        <S.ModalTitle>
          {getText('modal.samePrinterTitle', 'Same printer model?')}
        </S.ModalTitle>
      }
      maxWidth="480px"
      closeButton={true}
      footer={
        <S.StyledGroup>
          <S.CancelButton
            appearance="secondary"
            onClick={onClose}
          >
            {getText('modal.cancel', 'Cancel')}
          </S.CancelButton>
          <S.ProceedButton onClick={onProceed}>
            {getText('modal.proceedAnyway', 'Proceed anyway')}
          </S.ProceedButton>
        </S.StyledGroup>
      }
      alignFooter="end"
    >
      <S.ModalContent>
        <S.FirstParagraph>
          {getText(
            'modal.samePrinterDescription1',
            'You are selecting the same printer model that is already linked to your HP All-In Plan subscription.'
          )}
        </S.FirstParagraph>
        <S.SecondParagraph>
          {getText(
            'modal.samePrinterDescription2',
            'If your current printer is functioning well, you might consider keeping it and exploring the possibility of upgrading later. This way, you can maximize its use and choose a new model when the time is right.'
          )}
        </S.SecondParagraph>
      </S.ModalContent>
    </S.StyledModal>
  );
};

export default SamePrinterModal;
